/* eslint-disable import/no-cycle */
import {action, computed, decorate, observable} from 'mobx';
import {EntityStore} from './entityStore';
import {Api} from '../middleware/api';
import {MessageRead} from '../models/messageRead';

export class MessageReadStore extends EntityStore {
  messageReads = [];

  constructor(rootStore) {
    super(rootStore, 'messageReads', Api.messageReads, MessageRead);
  }

  getByMessageId(messageId) {
    return this.messageReads.filter((mr) => mr.messageId === messageId);
  }

  getByMessageIdAndUserId(messageId, userId) {
    return this.messageReads.find((mr) => mr.messageId === messageId && mr.userId === userId);
  }

  loadByMessageId(messageId) {
    this.messageReads = this.messageReads.filter((mr) => mr.messageId !== messageId);
    return this.loadAll({params: {messageId}});
  }

  get numberOfUnreadMessagesForCurrentUser() {
    const nRelevantMessages = this.rootStore.relevantMessagesStore.relevantMessages.length;
    const readCount = this.rootStore.relevantMessagesStore.relevantMessages
      .filter((message) => this.getByMessageIdAndUserId(message.id, this.rootStore.authStore.user?.id)).length;

    const result = nRelevantMessages - readCount;

    if (result < 0) {
      return 0;
    }

    return result;
  }
}

decorate(MessageReadStore, {
  messageReads: observable,
  numberOfUnreadMessagesForCurrentUser: computed,
  loadByMessageId: action,
});
